import {TabGroup, TabPanel, TabPanels} from '@headlessui/react'
import {create} from 'zustand'
import {useTranslation} from 'react-i18next'

import {DialogNew, Tab, TabList} from '@sdox/ui'

import {CookiePolicyContent} from './DialogContent/CookiePolicyContent'
import {PrivacyPolicyContent} from './DialogContent/PrivacyPolicyContent'
import {CookieSettingsContent} from './DialogContent/CookieSettingsContent'

export enum PrivacyDialogTab {
  PrivacyPolicy = 0,
  CookiePolicy = 1,
  CookieSettings = 2,
  None = 3,
}

export type useTabbedPrivacyDialogStoreState = {
  selectedTab: PrivacyDialogTab
  selectTab: (selectedTab: PrivacyDialogTab) => void
  closeDialog: () => void
}

export const useTabbedPrivacyDialogStore = create<useTabbedPrivacyDialogStoreState>((set) => ({
  selectedTab: PrivacyDialogTab.None,
  selectTab: (selectedTab: PrivacyDialogTab) => set({selectedTab}),
  closeDialog: () => set({selectedTab: PrivacyDialogTab.None}),
}))

export const TabbedPrivacyDialog = () => {
  const {t} = useTranslation()
  const selectedTab = useTabbedPrivacyDialogStore(state => state.selectedTab)
  const isOpen = selectedTab !== PrivacyDialogTab.None
  const selectTab = useTabbedPrivacyDialogStore(state => state.selectTab)
  const onClose = useTabbedPrivacyDialogStore(state => state.closeDialog)

  const onTabChange = (index: number): void => {
    if (
      index === PrivacyDialogTab.PrivacyPolicy ||
      index === PrivacyDialogTab.CookiePolicy ||
      index === PrivacyDialogTab.CookieSettings
    ) {
      selectTab(index)
    } else {
      selectTab(PrivacyDialogTab.None)
    }
  }

  return (
    <DialogNew
      size={'medium'}
      open={isOpen}
      onClose={onClose}
    >
      <TabGroup
        className={'contents'}
        selectedIndex={selectedTab}
        onChange={onTabChange}
      >
        <div
          className={'shrink-0 border-b px-spacing-32 pt-spacing-8 sm:px-spacing-40 sm:pt-spacing-16'}
        >
          <TabList>
            <Tab>{t('common:cookiesSettings')}</Tab>
            <Tab>{t('common:privacyPolicy')}</Tab>
            <Tab>{t('common:cookiesPolicy')}</Tab>
          </TabList>
        </div>
        <TabPanels className={'contents'}>
          <TabPanel className={'contents'}>
            <CookieSettingsContent onClose={onClose} />
          </TabPanel>
          <TabPanel className={'contents'}>
            <PrivacyPolicyContent onClose={onClose} />
          </TabPanel>
          <TabPanel className={'contents'}>
            <CookiePolicyContent onClose={onClose} />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </DialogNew>
  )
}
